import InputNumber from "./number";

export default InputNumber;
